'use strict';

var live = angular.module('gymsystem.live', []);

live.factory('live', ['$rootScope', '$window', '$q', '$timeout', 'jsoncoder', 'pubsub', function ($rootScope, $window, $q, $timeout, jsoncoder, pubsub) {
    var live = {};

    var isConnecting = false;
    var isActive = false;
    var isActivePubSub = false;  // when server respond ok
    var lastMessageId;
    var lastMessagePid;
    var ws;
    var setupWebSocket;
    var setupWebSocketTimer;
    var wsMessage;
    var socketTimer;
    var socketTimeout;
    var connectionDeferred = $q.defer();
    var pluginCommandId = 0;
    var pluginCommandListeners = {};
    var channel2Broker, channel2onWsOpen;

    var observers = {};
    function subscribeKey(key, option) {
        if(!option.callback) {return;}
        var list = observers[key];
        if(!list) {
            observers[key] = list = [];
        }
        list.push(option.callback);

        var unsubscribe = function() {
            var i = list.indexOf(option.callback);
            if(i>=0) {
                list.splice(i, 1);
            }
        };

        if(option.scope) {
            option.scope.$on('$destroy', unsubscribe);
        }
        return unsubscribe;
    }
    function publishKey(key, event) {
        var list = observers[key];
        if(!list) {return false;}
        for(var i=0;i<list.length;i++) {
            try {
                list[i](event.data[0], event);
            } catch (e) {
                console.error(e);
            }
        }
        return list.length > 0;
    }
    function publishEvent(event) {
        var type = event.type || '';
        var action = event.action || '';
        var runApply = false;
        runApply |= publishKey(type + ':', event);
        runApply |= publishKey(type + ':' + action, event);
        if (runApply) {
            $rootScope.$apply();
        }
    }
    live.subscribe = function(option) {
        option.type = option.type || '';
        option.action = option.action || '';
        return subscribeKey(option.type + ':' + option.action, {
            callback: option.callback,
            scope: option.scope
        });
    };

    var wsOpen = function() {
        //console.log('Opened connection');
        connectionDeferred.resolve();
        isConnecting = false;
        isActive = true;
        $rootScope.pubsub.publish('live.connect', true);
        channel2onWsOpen();
    };

    var wsClose = function() {
        //console.log('Connection closed');
        isConnecting = false;
        isActive = false;
        isActivePubSub = false;
        if (!setupWebSocketTimer) {
            setupWebSocketTimer = window.setTimeout(setupWebSocket, 1000);
        }
    };

    var wsError = function() {
        //console.log('Error on websocket');
        isConnecting = false;
        isActive = false;
        isActivePubSub = false;
        if (!setupWebSocketTimer) {
            setupWebSocketTimer = window.setTimeout(setupWebSocket, 1000);
        }
    };

    var resetSocketTimer = function() {
        if (setupWebSocketTimer) {
            window.clearTimeout(setupWebSocketTimer);
        }
        if (socketTimer) {
            window.clearInterval(socketTimer);
        }
        socketTimer = window.setInterval(socketTimeout, 10000);
    };

    socketTimeout = function() {
        setupWebSocket();
    };

    setupWebSocket = function() {
        if(setupWebSocketTimer) {
            window.clearTimeout(setupWebSocketTimer);
            setupWebSocketTimer = null;
        }
        if (isConnecting) {
            return;
        }

        //console.log("Trying to connect...");
        if (ws) {
            ws.onerror = undefined;
            ws.onclose = undefined;
            ws.close();
            connectionDeferred = $q.defer();
        }

        isConnecting = true;
        isActive = false;
        isActivePubSub = false;
        var url = live.options.url;
        if(document.location.protocol == 'http:') {
            // not secure connection, change wss to ws
            url = url.replace(/^wss\:/, 'ws:');
        }
        ws = new WebSocket(url);
        ws.onopen = wsOpen;
        ws.onclose = wsClose;
        ws.onerror = wsError;
        ws.onmessage = wsMessage;
        resetSocketTimer();
    };

    wsMessage = function(event) {
        resetSocketTimer();
        //var message = JSON.parse(event.data);
        var message = jsoncoder.decode(JSON.parse(event.data));

        if (message.type == 'ping') {
            return;
        }

        //console.log('Got message of type ' + message.type + ' with id ' + message.id);

        // REMOVED IN IN-139: FIX FOR BUG-621
        // FIXME: Implement reloading in better way
        //        in the future.
        // if (message.type == 'reload') {
        //     if(message.delay) {
        //         setTimeout(function() {
        //             $window.location.reload();
        //         }, message.delay * 1000);
        //     } else {
        //         $window.location.reload();
        //     }
        //     return;
        // }
        if (message.type == 'reload') {
            if (location.hostname.endsWith('zoezidev.se')) {
                $window.location.reload();
            }
            return;
        }

        if (message.type == 'last') {
            if (lastMessageId && (message.id > lastMessageId+10 || message.pid != lastMessagePid)) {
                // Reload - we lost connection
                $window.location.reload();
                return;
            }
            if(!isActivePubSub) {
                isActivePubSub = true;
                $rootScope.pubsub.publish('live.active', true);
            }
        }

        if(message.type === 'channel2') {
            return channel2Broker(message);
        }

        publishEvent(message);

        if (message.type == 'plugin') {
            var pluginData = message.data;
            if (pluginData.id) {
                var callback = pluginCommandListeners[pluginData.id];
                if (callback) {
                    $rootScope.$apply(function() {
                        callback(message.data.result);
                    });
                }
            }
            return;
        }

        lastMessageId = message.id;
        lastMessagePid = message.pid;

        var numMessages = message.data ? message.data.length : 0;

        var options = { sendServerChangeEvent: true, runApply: false };

        for (var i=0; i < numMessages; ++i) {
            var messageData = message.data[i];

            live.options.handleMessage(message, messageData, options);
        }

        if (options.runApply) {
            $rootScope.$apply();
        }

        if (message.type == 'workout' && (message.action == 'remove' || message.action == 'add' || message.action == 'change')) {
            $rootScope.$broadcast('workoutsChanged');
        }

        if (options.sendServerChangeEvent) {
            $rootScope.$broadcast('serverChange', message);
        }
    };

    live.waitActive = function(timeout) {
        return $q.promise(function(resolve, reject) {
            var done = false;
            if(isActive) {
                resolve();
                return;
            }
            setupWebSocket();

            function liveActive() {
                $rootScope.pubsub.unsubscribe('live.active', liveActive);
                if(done) {return;}
                done = true;
                resolve();
            }
            $rootScope.pubsub('live.active', liveActive);

            if(timeout) {
                setTimeout(function() {
                    $rootScope.pubsub.unsubscribe('live.active', liveActive);
                    if(done) {return;}
                    done = true;
                    reject('timeout');
                }, timeout);
            }
        });
    };

    live.isActive = function() {
        return !!ws;
    };

    live.start = function(options) {
        live.options = options;
        setupWebSocket();
    };

    live.stop = function() {
        if (ws) {
            ws.onerror = undefined;
            ws.onclose = undefined;
            ws.close();
            if (setupWebSocketTimer) {
                window.clearTimeout(setupWebSocketTimer);
                setupWebSocketTimer = null;
            }
            if (socketTimer) {
                window.clearInterval(socketTimer);
                socketTimer = null;
            }
            ws = null;
            isConnecting = false;
            lastMessageId = undefined;
            lastMessagePid = undefined;
            pluginCommandId = 0;
            pluginCommandListeners = {};
            connectionDeferred = $q.defer();
        }
    };

    live.sendToChannel = function(key, data) {
        ws.send(JSON.stringify({type: 'channel', key: key, data: data}));
    };

    live.channel2 = (function() {
        var callbacks = {};
        var ids = {};

        channel2Broker = function(message) {
            if(!callbacks[message.key]) {return;}
            ids[message.key] = message.id;
            callbacks[message.key].forEach(function(fn) {
                fn(message.data);
            });
        };

        channel2onWsOpen = function() {
            for(var key in callbacks) {
                var lastId = ids[key];
                ws.send(JSON.stringify({type: 'channel2', command: 'on', key: key, lastId: lastId}));
            }
        };

        function cancel(key, fn) {
            if(ws && ws.readyState === 1) {
                ws.send(JSON.stringify({type: 'channel2', command: 'off', key: key}));
            }
            if(!callbacks[key]) {return;}
            var i = callbacks[key].indexOf(fn);
            if(i<0) {return;}
            callbacks[key].splice(i, 1);
            if(!callbacks[key].length) {delete callbacks[key]; delete ids[key];}
        }

        return function(scope, key, fn) {
            if(ws && ws.readyState === 1) {
                ws.send(JSON.stringify({type: 'channel2', command: 'on', key: key, lastId: 0}));
            }

            if(!callbacks[key]) {callbacks[key]=[];}
            callbacks[key].push(fn);

            if(scope) {
                scope.$on('$destroy', function() {
                    cancel(key, fn);
                });
            }

            return function() {
                cancel(key, fn);
            };
        };
    })();

    var sessionToSend;
    live.authenticate = function(session) {
        sessionToSend = session;
        if(!isActive) {return;}
        ws.send(JSON.stringify({type: 'auth', data: sessionToSend}));
    };
    pubsub.subscribe('live.connect', function() {
        if(!sessionToSend) {return;}
        ws.send(JSON.stringify({type: 'auth', data: sessionToSend}));
    });

    live.pluginCommand = function(plugin, command, data, timeout) {
        return connectionDeferred.promise.then(function() {
            var deferred = $q.defer();
            var timer;

            var id = ++pluginCommandId;

            if (timeout) {
                timer = $timeout(function() {
                    if (pluginCommandListeners[id]) {
                        delete pluginCommandListeners[id];
                        deferred.reject();
                    }
                }, timeout);
            }

            var pluginCommandData = { id: id, plugin: plugin, command: command, data: data };
            pluginCommandListeners[id] = function(response) {
                $timeout.cancel(timer);
                delete pluginCommandListeners[id];
                deferred.resolve(response);
            };

            ws.send(JSON.stringify({type: 'plugin', data: pluginCommandData}));

            return deferred.promise;
        });
    };

    return live;
}]);
